import { render, staticRenderFns } from "./montes-folly.vue?vue&type=template&id=9ac9c128&scoped=true"
import script from "./montes-folly.vue?vue&type=script&lang=js"
export * from "./montes-folly.vue?vue&type=script&lang=js"
import style0 from "./montes-folly.vue?vue&type=style&index=0&id=9ac9c128&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ac9c128",
  null
  
)

export default component.exports